import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Section1AR from "../../components/LandingPage/Section1AR/Section1AR";
import Section3 from "../../components/LandingPage/Section3/Section3";
import "./Employers.css";
import AIEmployerForm from "./AIEmployerForm";
import Slider from "react-slick";
import { Helmet } from 'react-helmet';

export default function AIAccountsReceivable() {

  const [expanded, setExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="employersPageWrap">
      <Helmet>
        <title>Access Intell Invoice Chaser Call Demo</title>
      </Helmet>
      <Section1AR
        heading={
          <>
            <div className=" fw-bold heading">
              Access Intell<br />
              <span className=" px-2" style={{ background: "#9256E8" }}>
                Invoice Chaser
              </span>{" "}<br />
              Call Demo<br />
            </div>
          </>
        }
        subHeading="Access Intell's advanced AI takes the hassle out of chasing unpaid invoices, so you can focus on growing your business. Our intelligent AI system calls all your customers with outstanding invoices, maintaining a professional and friendly tone, reminding them of outstanding invoices and facilitating immediate payments."
        buttons={
          <>
          </>
        }
        image={
          <>
            <AIEmployerForm />
          </>
        }
        mobileImage={
          <>
            <AIEmployerForm />
          </>
        }
      />
      <div className="section2">
      </div>
    </div>
  );
}
